import Component from '../Component';
import LoadingIndicator from './LoadingIndicator';
import classList from '../utils/classList';
import withAttr from '../utils/withAttr';
import Icon from './Icon';
/**
 * The `Checkbox` component defines a checkbox input.
 *
 * ### Attrs
 *
 * - `state` Whether or not the checkbox is checked.
 * - `className` The class name for the root element.
 * - `disabled` Whether or not the checkbox is disabled.
 * - `loading` Whether or not the checkbox is loading.
 * - `onchange` A callback to run when the checkbox is checked/unchecked.
 * - `children` A text label to display next to the checkbox.
 */
export default class Checkbox extends Component {
  view(vnode) {
    const className = classList(['Checkbox', this.attrs.state ? 'on' : 'off', this.attrs.className, this.attrs.loading && 'loading', this.attrs.disabled && 'disabled']);
    return m("label", {
      className: className
    }, m("input", Object.assign({
      type: "checkbox",
      checked: this.attrs.state,
      disabled: this.attrs.disabled,
      onchange: withAttr('checked', this.onchange.bind(this))
    }, this.attrs.inputAttrs ?? {})), m("div", {
      className: "Checkbox-display",
      "aria-hidden": "true"
    }, this.getDisplay()), vnode.children);
  }

  /**
   * Get the template for the checkbox's display (tick/cross icon).
   */
  getDisplay() {
    return this.attrs.loading ? m(LoadingIndicator, {
      display: "unset",
      size: "small"
    }) : m(Icon, {
      name: this.attrs.state ? 'fas fa-check' : 'fas fa-times'
    });
  }

  /**
   * Run a callback when the state of the checkbox is changed.
   */
  onchange(checked) {
    if (this.attrs.onchange) this.attrs.onchange(checked, this);
  }
}
flarum.reg.add('core', 'common/components/Checkbox', Checkbox);